import * as ReactDOM from 'react-dom'
import * as React from 'react'
import { App } from './App';

// Render the UI to the screen
ReactDOM.render(<App />, document.getElementById('container'));